var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row flex-md-column align-center mx-8 mx-md-1 justify-space-between w-full"},[_c('span',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":25,"width":3}}):_c('h3',[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }